/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-04-01 13:44:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-05-11 14:12:59
 */
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getToken } from '@/base/cookie'
import { Message } from 'element-ui'
// import layout from '@/views/layout/index.vue'
Vue.use(Router)
// createData //造数据助手的模块
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录' }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index')
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import('@/views/DataAssistant/homePage'),
    meta: { title: '首页' },
    createData: true
  },
  {
    path: '/grabList',
    name: 'grabList',
    component: () => import('@/views/DataAssistant/grabList'),
    meta: { title: '抓取列表' },
    createData: true
  },
  {
    path: '/codeLogin',
    name: 'codeLogin',
    component: () => import('@/views/DataAssistant/codeLogin'),
    meta: { title: '扫码登录' },
    createData: true
  },
  { path: '/404', component: () => import('@/views/404/index') }
]
const vueRouter = new Router({
  mode: 'hash',
  routes: routes
})


vueRouter.beforeEach(async (to, from, next) => {
  if (to.path.indexOf('/login') < 0) {	// 跳转非登录相关页
    if (getToken()) {
      if (!store.state.userInfo.bloginName) {
        await store.dispatch('setUserInfo')
      }
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})
export default vueRouter
